module.exports = __webpack_public_path__ + "static/img/SY.81b6fb6d.svg";